<template>
  <div
    v-if="stockLabel"
    class="body-2-bold mt-2"
    :class="{
      'text-static-success-hi': props.stockLabel === STOCK_GOOD_STATUS,
      'text-static-brand-mid': props.stockLabel !== STOCK_GOOD_STATUS,
    }"
  >
    {{ stockLabel }}
  </div>
</template>

<script lang="ts" setup>
/**
 * Displays the stock count string, calculated from the selectedOffer.stockLabel property
 */
import { computed } from 'vue'

import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'

import { STOCK_GOOD_STATUS } from './StockLabel.constants'

const props = withDefaults(
  defineProps<{
    stockLabel: NonNullable<GetPickersResponse['selectedOffer']>['stockLabel']
  }>(),
  {
    stockLabel: null,
  },
)

const stockLabel = computed(() => {
  return props.stockLabel
})
</script>
